export const iconFontAwesomeMedicalHealthPoop = (
	<i className="fa-solid fa-poop"></i>
);
